import { arrayMove } from "@dnd-kit/sortable"
import type { KeyboardEventHandler } from "react"

import type { ColumnConfigItem } from "../../containers/User/redux/ui-preferences.types"

export const MIN_COLUMN_WIDTH = 100
export const MAX_COLUMN_WIDTH = 600

export function reorderConfig(
  config: ColumnConfigItem[],
  activeKey: string,
  overKey: string
): ColumnConfigItem[] {
  const oldIdx = config.findIndex((item) => item.key === activeKey)
  const newIdx = config.findIndex((item) => item.key === overKey)
  if (oldIdx < 0 || newIdx < 0) return config
  return arrayMove(config, oldIdx, newIdx)
}

export function applyWidthsToConfig(
  config: ColumnConfigItem[],
  widths: Record<string, number>
): ColumnConfigItem[] {
  return config.map((item) =>
    widths[item.key] != null ? { ...item, width: widths[item.key] } : item
  )
}

export type HeaderKeyDown =
  | KeyboardEventHandler<HTMLTableCellElement>
  | undefined

/**
 * One `onKeyDown` for a header cell that two libraries both want.
 *
 * Enter reaches the sort and never the lift. The split is here rather than on
 * the sensor because the same sensor serves the row grips, where Enter is a
 * way to pick a row up; Space still lifts a column.
 *
 * `dragInProgress` is for the Enter that *ends* a drag — it must not flip the
 * sort on its way out.
 */
export function mergeHeaderKeyDown(
  fromTable: HeaderKeyDown,
  startDrag: HeaderKeyDown,
  { dragInProgress }: { dragInProgress: boolean }
): KeyboardEventHandler<HTMLTableCellElement> {
  return (event) => {
    if (dragInProgress) return
    fromTable?.(event)
    if (event.key === "Enter") return
    startDrag?.(event)
  }
}
